exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer-btns[data-v-195e73a3]{position:absolute;bottom:30px;text-align:right;width:100%}.load-wrapper[data-v-195e73a3]{max-height:calc(100vh - 200px);overflow-y:auto}", ""]);

// exports
